module.exports = __webpack_public_path__ + "assets/dcd3c2f1e4280a80937f8de2552a4599.png";